module.exports = __webpack_public_path__ + "img/exp1.4907f77e.png";